import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../store";
import {updateSubscribedBiasUsersDB} from "../api/api-subscribed-bias";
import UserSubscribedBias from "../datatypes/UserSubscribedBias";


export interface SubscribedUserState {
    data: typeof UserSubscribedBias[],
    loading: boolean,
    error: any
}

const initialState: SubscribedUserState = {
    data: [],
    loading: false,
    error: null,
}

export const updateSubscribedBiasUsersDBThunk = createAsyncThunk(
    'main/updatesubscribedbias',
    async ({uid, symbol, traderType, discordUsername, dropDownSelectedBiasList}: { uid: number, symbol: string, traderType: string, discordUsername: string, dropDownSelectedBiasList: number[] }) => {
        const response = await updateSubscribedBiasUsersDB(uid, symbol, traderType, discordUsername, dropDownSelectedBiasList);
        return response?.data;
    }
)

export const updateUserSubscribedBiasReducer = createSlice({
    name: 'main',
    initialState,
    reducers: {
        updateSubscribedUserData: (state: SubscribedUserState, action: PayloadAction<typeof UserSubscribedBias[]>) => {
            state.data = action.payload;
        },
        updateSubscribedProgress: (state: SubscribedUserState, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateSubscribedBiasUsersDBThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateSubscribedBiasUsersDBThunk.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(updateSubscribedBiasUsersDBThunk.rejected, (state, action) => {
                state.loading = false; 
                state.error = action.error.message;
            })
    },
})

export const {
    updateSubscribedUserData, updateSubscribedProgress
} = updateUserSubscribedBiasReducer.actions;

export const selectSubscribedUserData = (state: RootState) => state.updateUserSubscribedBiasData.data;
export const selectSubscribedProgress = (state: RootState) => state.updateUserSubscribedBiasData.loading;

export default updateUserSubscribedBiasReducer.reducer;